import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeQuoteCargoTypesList } from './normalize';

export const fetchQuoteCargoTypesList = createProvider(api.fetchQuoteCargoTypesList)
  .andThen((res) => normalizeQuoteCargoTypesList(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
